import React from 'react'
import { CartesianGrid, XAxis, YAxis, BarChart, Bar, Tooltip } from 'recharts'
import Styles from './chart.module.scss'
import { format } from 'date-fns'
import AnimationButton from '../AnimationButton'
import Modal from '../Modal'
import Cstyles from '../../Layouts/DetailModal/DetailModal.module.scss'
import ContentStyles from '../../Layouts/DetailModal/ModalContent/modalContent.module.scss'

const Chart = ({ getData }) => {
  const [displayHours, setDisplayHours] = React.useState(true)
  const [openDialog, setOpenDialog] = React.useState(false)
  const [data, setData] = React.useState([])

  const formatSize = (d) => {
    if (!d) return `${(0).toFixed(2)} MB`
    d /= 1073741824
    if (Math.abs(d) < 0.5) {
      return `${(d * 1024).toFixed(2)} MB`
    } else if (Math.abs(d) > 1024) {
      return `${(d / 1024).toFixed(2)} TB`
    }
    return `${d.toFixed(2)} GB`
  }

  const formatDate = (date_string, hours) => {
    return hours
      ? format(date_string, 'MMM dd HH:mm')
      : format(date_string, 'MMM dd')
  }

  const toggleModal = async () => {
    if (!openDialog)
      try {
        const d = await getData()
        if (d && Array.isArray(d)) {
          setData(d)
          setOpenDialog(true)
        }
      } catch (err) {
        alert(err)
        console.error('Error fetching data:', err)
      }
    else setOpenDialog(false)
  }

  return (
    <>
      <AnimationButton
        width="182px"
        height="32px"
        background="linear-gradient(316deg, #FFA329 4.43%, #FE7B1C 56.59%, #FC2A01 150.36%)"
        color="#FFF"
        size="13px"
        borderRadius="10px"
        button="yellow"
        label="Chart"
        handler={toggleModal}
      />
      {openDialog && (
        <Modal show={openDialog} variant={Cstyles.modal}>
          <div
            className={Cstyles.container}
            style={{ width: '100%', margin: 'auto' }}
          >
            <div
              className={`analytics-container ${ContentStyles.analytics_container}`}
            >
              <div
                className={Styles.graphWrapper + ' graphWrapper'}
                Styles={{ position: 'relative' }}
                onScroll={(e) => {
                  const scrollLeft = e.currentTarget.scrollLeft
                  document.querySelectorAll('.yAxis')?.forEach((axis) => {
                    const rect = document.createElementNS(
                      'http://www.w3.org/2000/svg',
                      'rect'
                    )
                    const yAxisheight = axis.getBoundingClientRect().height
                    const yAxisWidth = axis.getBoundingClientRect().width
                    rect.setAttribute('x', '0')
                    rect.setAttribute('y', '0')
                    rect.setAttribute('width', yAxisWidth)
                    rect.setAttribute('height', yAxisheight + 20)
                    rect.setAttribute('fill', 'var(--bg-color)')
                    axis.insertBefore(rect, axis.firstChild)
                    const position = scrollLeft
                    axis.style.transform = `translateX(${position}px)`
                  })
                }}
              >
                <BarChart
                  height={500}
                  width={data.length * 20}
                  className={Styles.chart}
                  data={data}
                  margin={{
                    top: 5,
                    right: 0,
                    left: 0,
                    bottom: 5,
                  }}
                  barGap={10}
                >
                  <Bar
                    dataKey="data"
                    fill="#FE7B1C"
                    radius={[12, 12, 0, 0]}
                    stroke="#FC2A01"
                    strokeWidth={1}
                  />
                  <CartesianGrid
                    stroke="var(--re-border-color)"
                    strokeDasharray="4 5"
                  />
                  <XAxis
                    tickMargin={10}
                    interval={'equidistantPreserveStart'}
                    dataKey="timestamp"
                    tickFormatter={(value) => {
                      return formatDate(value, displayHours)
                    }}
                  />
                  <YAxis
                    tickLine={false}
                    tickMargin={10}
                    axisLine={false}
                    tickFormatter={formatSize}
                    width={100}
                    fill="var(--bg-color)"
                  />
                  <Tooltip
                    separator=": "
                    useTranslate3d
                    labelFormatter={(value) => formatDate(value, displayHours)}
                    formatter={(value) => {
                      return formatSize(value)
                    }}
                    cursor={false}
                    contentStyle={{
                      backgroundColor: 'var(--bg-color)',
                      borderColor: 'var(--re-border-color)',
                      color: 'var(--font-color)',
                    }}
                  />
                </BarChart>
              </div>
              <div className={ContentStyles.button}>
                <AnimationButton
                  width="132px"
                  height="42px"
                  background="var(--re-black-yellow-bg)"
                  color="var(--font-color)"
                  size="16px"
                  borderRadius="12px"
                  button="special"
                  label="Close"
                  handler={(e) => toggleModal(e)}
                />
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  )
}

export default Chart
